import { usePrices } from '../hooks/support'
import { useUser } from '../hooks/user'
import { formatPrice } from './formatPrice'
import css from '../style.module.scss'
import { t } from '../hooks/translations'

export const OfferNote = function OfferNote() {
  const { offer } = useUser()
  const { currency, monthly, annually } = usePrices()

  if (offer === 'yearly') {
    return (
      <p className={css['signup-note']}>
        {t('youre_saving', {
          sum: formatPrice({
            prefix: currency.prefix,
            unitAmount: (monthly.unit_amount * 12 - annually.unit_amount) / 100
          })
        })}
      </p>
    )
  }

  return <p className={css['signup-note']}>{t('cancel_anytime')}</p>
}
